import { Box, Button, Modal, Stack, Text, Title } from "@mantine/core";
import { IconCircleCheck } from "@tabler/icons-react";
import { mdiRecordCircle } from "@mdi/js";
import Icon from "@mdi/react";
import { COLORS } from "@/utils/GlobalStyles";

type QuickRecordUploadSuccessModalProps = {
  modalOpened: boolean;
  setModalOpened: (value: boolean | null) => void;
  onRecord: () => void;
  onViewCases: () => void;
};

const QuickRecordUploadSuccessModal = (
  props: QuickRecordUploadSuccessModalProps,
) => {
  const { modalOpened, setModalOpened, onRecord, onViewCases } = props;

  return (
    <Modal
      opened={modalOpened}
      onClose={() => {
        setModalOpened(false);
      }}
      centered
      title={""}
    >
      <Box pl={50} pr={50} pb={50}>
        <Stack align="center" gap={30} mb={30}>
          <IconCircleCheck size={120} color={COLORS.primary} />
          <Title fw={600} fz={24}>
            Case saved!
          </Title>
          <Text fw={500} fz={16} ta={"center"}>
            Your patient case and recording has successfully been saved.
          </Text>
        </Stack>
        <Stack mt="md">
          <Button
            variant="primary"
            h={50}
            w={"100%"}
            radius={50}
            onClick={() => {
              setModalOpened(false);
              onViewCases();
            }}
          >
            View patient cases
          </Button>
          <Button
            variant="outline"
            h={50}
            w={"100%"}
            radius={50}
            leftSection={<Icon path={mdiRecordCircle} size={0.7} />}
            onClick={() => {
              setModalOpened(false);
              onRecord();
            }}
          >
            Record again
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default QuickRecordUploadSuccessModal;
